// reference: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API

const $masthead = $('header.masthead');

let observers = [];

let previousY = [],
    previousRatio = [];

startup = () => {
    let observerOptions = {
        threshold: [] // contains percentages (0 is zero, 1 is 100% of element visible in viewport in all directions) to trigger callback on
    }

    const $sections = $('[data-dynamic-background-color]');

    let i = 0;
    $sections.each(function () {
        // calculate start/end threshold for each element individually based on element size, based on # font-size units
        let threshold = (parseInt($('body').css('fontSize')) * 10) / $(this).outerHeight();

        if (threshold > 0.2) threshold = 0.2;

        observerOptions.threshold = [threshold, 0.25, 0.5, 0.75];

        observers[i] = new IntersectionObserver(intersectionCallback, observerOptions);
        observers[i].observe($(this)[0]);

        previousY[i] = 0;
        previousRatio[i] = 0;

        $(this).attr('data-observer-id', i);

        i++;
    });
};

function intersectionCallback(entries) {
    entries.forEach((entry) => {
        const color = $(entry.target).attr('data-dynamic-background-color'),
            observerID = parseInt($(entry.target).attr('data-observer-id'));

        if (color) {
            let currentBodyColor = $('body')[0].style.backgroundColor;

            const currentY = entry.boundingClientRect.y,
                currentRatio = entry.intersectionRatio,
                isIntersecting = entry.isIntersecting;

            if (currentY < previousY[observerID]) { // scrolling down
                if (currentRatio > previousRatio[observerID]) {
                    // console.log("Scrolling down, element enter");

                    if (isIntersecting) $('body').css('background-color', color);
                } else {
                    // console.log("Scrolling down, element leave");

                    if (color === currentBodyColor && currentRatio < 0.25) {
                        $('body').css('background-color', '');
                    }
                }
            } else if (currentY > previousY[observerID]) { // scrolling up
                if (currentRatio < previousRatio[observerID]) {
                    // console.log("Scrolling up, element leave");

                    if (color === currentBodyColor && currentRatio < 0.25) {
                        $('body').css('background-color', '');
                    }
                } else {
                    // console.log("Scrolling up, element enter");

                    if (isIntersecting) $('body').css('background-color', color);
                }
            }

            previousY[observerID] = currentY;
            previousRatio[observerID] = currentRatio;
        }
    });
}

startup();
